import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { AuthenticationResult } from '@azure/msal-common/browser';
import { BehaviorSubject, debounceTime, firstValueFrom, of } from 'rxjs';
import { environment } from '../environments/environment';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { VerifyPopupComponent } from '../dashboard/components/verify-popup/verify-popup.component';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private BE_URL = '';
  private _request: any = null;
  private dialogService: DialogService = inject(DialogService);
  ref: DynamicDialogRef | null = null;

  loginState$: BehaviorSubject<any> = new BehaviorSubject(null);
  isReady2Verify: boolean = false;

  constructor(
    private httpClient: HttpClient,
  ) {
    this.BE_URL = environment.API_URL;
    this.loginState$.pipe(debounceTime(10000)).subscribe((value) => {
      if (value) {
        this.login();
      }
    });
  }

  ngOnInit() {
    // const account = this.getActiveAccount();
    // this._request = {
    //   account,
    //   scopes: [`user.read`],
    // };
  }

  // private getActiveAccount(): AccountInfo {
  //   const account = this.msalService.instance.getActiveAccount();

  //   if (!account) {
  //     const accounts = this.msalService.instance.getAllAccounts();
  //     if (accounts.length > 0) {
  //       this.msalService.instance.setActiveAccount(accounts[0]);
  //       return accounts[0];
  //     }
  //     throw new Error('No active account');
  //   }

  //   return account;
  // }

  // async getAccessToken(): Promise<string> {
  //   const account = this.getActiveAccount();

  //   const result: AuthenticationResult = await firstValueFrom(
  //     this.msalService.acquireTokenSilent({
  //       account,
  //       scopes: [`user.read`],
  //     }),
  //   );

  //   return result.accessToken;
  // }

  login(): void {
    if (this.isReady2Verify) {
      return;
    }

    this.postStartLogin().subscribe({
      next: (res: any) => {
        if (res && res.data) {
          const { userCode, verificationUri, deviceCode } = res.data;
          if (verificationUri) {
            this.show({ userCode, verificationUri, deviceCode });
          }
        }
      },
      error: (err: any) => console.error(err),
    });
  }

  postStartLogin() {
    this.isReady2Verify = true;
    const url = this.BE_URL + '/auth/start';
    return this.httpClient.post(url, null);
  }

  postStartPoll(deviceCode: string) {
    const url = this.BE_URL + '/auth/poll';
    return this.httpClient.post(url, { deviceCode });
  }

  logout() {
    localStorage.clear();
    const url = this.BE_URL + '/auth/logout';
    this.httpClient.delete(url).subscribe({
      next: (res: any) => {
        this.login();
      },
      error: (err: any) => console.error(err),
    });
  }

  show({ userCode, verificationUri, deviceCode }: any) {
    this.ref = this.dialogService.open(VerifyPopupComponent, {
      header: 'Login Device',
      data: { userCode, verificationUri },
      style: {
        width: '35vw',
        fontSize: '2.7rem',
        paddingLeft: '1.2rem',
        paddingRight: '1.2rem',
      },
    });

    this.ref?.onClose.subscribe(() => {
      this.postStartPoll(deviceCode).subscribe({
        next: (res: any) => {
          // console.log({pollRes: res});
          if (res && res.data) {
            const { accessToken } = res.data;
            if (accessToken) {
              localStorage.setItem('accessToken', accessToken);
              this.isReady2Verify = false;
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          }
        },
        error: (err: any) => {
          console.error(err);
        },
      });
    });
  }
}
